(function (Drupal) {
  Drupal.behaviors.breadcrumb = {
    attach: function (context) {

      // Only run once per page load.
      if (context !== document) return;

      if (window.innerWidth < 499) {
        const breadcrumb = document.querySelector('#block-kruimelpad ol');
        if (!breadcrumb) return;

        const items = breadcrumb.querySelectorAll('li');
        const liCount = items.length;

        if (liCount > 3) {
          // Convert NodeList to array so we can filter
          const liArray = Array.from(items);

          liArray.forEach((li, index) => {
            const isFirst = index === 0;
            const isSecondLast = index === liCount - 2;
            const isLast = index === liCount - 1;

            if (!isFirst && !isSecondLast && !isLast) {
              li.remove();
            }
          });
        }
      }
    }
  };
})(Drupal);
